import React from "react";

const NotFoundPage = () => {
  return <>Page not found</>;
};

export default NotFoundPage;
